import { Fork, Invoke } from '@swf/components/StarsWizard/Flow';
import type { FlowConfig } from '@swf/core/types/Wizard';

import RMFAddress from '../components/RMFAddress/RMFAddress';
import RMFCompleted from '../components/RMFCompleted/RMFCompleted';
import RMFDepositLimit from '../components/RMFDepositLimit/RMFDepositLimit';
import RMFIdentityVerification from '../components/RMFIdentityVerification/RMFIdentityVerification';
import RMFLossLimit from '../components/RMFLossLimit/RMFLossLimit';
import RMFPlayingTimeLimit from '../components/RMFPlayingTimeLimit/RMFPlayingTimeLimit';

import useRMFBaseSteps from './useRMFBaseSteps';
import { Guard } from './useRmfGuards';
import { Service } from './useRmfServices';

const useRmfGRFlow = (): FlowConfig => {
  const {
    forkDobCheck,
    jumpToFeatureStep,
    invokeLegalNameSave,
    forkRmfExit,
    forkJumpToFeature,
    invokeFetchUserDepositLimit,
    invokeFetchLossLimits
  } = useRMFBaseSteps();

  const invokeSignupDob: Invoke = new Invoke(Service.SignupDobFetch, invokeFetchUserDepositLimit);

  const invokeAddressSave = new Invoke(Service.RmfAddressSave, RMFIdentityVerification, RMFAddress);

  const invokeIdentityVerificationSave = new Invoke(
    Service.RmfIdentifyVerificationSaveGR,
    RMFDepositLimit,
    RMFIdentityVerification
  );

  const invokeDepositLimitSave: Invoke = new Invoke(Service.RmfDepositLimitSave, RMFLossLimit);

  const invokeNetLimitSave: Invoke = new Invoke(Service.RmfLossLimitSave, RMFPlayingTimeLimit);

  const forkStandaloneRMFCheck = new Fork(Guard.HideRMFCompletion, [forkRmfExit], RMFCompleted);

  const invokeEnableRealMoneyFlag = new Invoke(
    Service.RmfEnableRealMoneyFlag,
    forkStandaloneRMFCheck
  );

  const invokePlayingTimeLimitSave: Invoke = new Invoke(
    Service.RmfGRPlayingTimeSave,
    invokeEnableRealMoneyFlag
  );

  return [
    invokeSignupDob,
    invokeFetchUserDepositLimit,
    invokeFetchLossLimits,
    forkDobCheck,
    invokeLegalNameSave,
    RMFAddress,
    invokeAddressSave,
    RMFIdentityVerification,
    invokeIdentityVerificationSave,
    RMFDepositLimit,
    invokeDepositLimitSave,
    RMFLossLimit,
    invokeNetLimitSave,
    RMFPlayingTimeLimit,
    invokePlayingTimeLimitSave,
    invokeEnableRealMoneyFlag,
    forkStandaloneRMFCheck,
    RMFCompleted,
    forkJumpToFeature,
    jumpToFeatureStep
  ];
};

export default useRmfGRFlow;
